var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientCareDischargeIcon = function SvgPatientCareDischargeIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M14.128 18.1l1.01 1.011L18.75 15.5l-3.611-3.611-1.011 1.01 1.878 1.879H9v1.444h6.97L14.127 18.1zM20.556 9H10.444C9.65 9 9 9.65 9 10.444v2.89h1.444v-2.89h10.112v10.112H10.444v-2.89H9v2.89C9 21.35 9.65 22 10.444 22h10.112C21.35 22 22 21.35 22 20.556V10.444C22 9.65 21.35 9 20.556 9z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientCareDischargeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/patient-care-discharge-icon.f33609dd1fcdffae549500e9416e658a.svg";